// Script to auto-switch to available band color if selected color is out of stock

const currentProduct = document.currentScript?.dataset?.product;

const defaultColors = ["Black", "Blue", "Green", "Red", "Purple", "Mint", "Yellow", "White"];
const defaultBandColors = ["Black", "Grey", "Blue", "Green", "Pink", "Purple", "Sand", "White"];
const walletColors = ["Black", "Slate", "White", "Maroon"]
document.addEventListener('DOMContentLoaded', (event) => {
  const productToUse = currentProduct || "dot.band";
  const colorsToUse = productToUse === "dot.band" ? 
    defaultBandColors 
    : productToUse === "dot.wallet" ? 
      walletColors 
      : defaultColors;

  const allBasicProductsElem = productToUse === 'dot.wallet' ? 
    document.querySelector("#shopify-product-item") : document.querySelector("#all-basic-products");
  if (!allBasicProductsElem) return;
  let allBasicProducts = JSON.parse(allBasicProductsElem.textContent || "[]");
  if (!allBasicProducts || (Array.isArray(allBasicProducts) && allBasicProducts.length === 0)) return;
  if (!Array.isArray(allBasicProducts)) allBasicProducts = [allBasicProducts];
  const allProductsCurrent = allBasicProducts.find(product => product.title === productToUse);
  if (!allProductsCurrent) return;

  const currentVariants = productToUse === "dot.band" ? 
    allProductsCurrent.variants.filter(variant => variant.option2 === "Single" && variant.option3 === "2.0" && colorsToUse.includes(variant.option1)) 
    : allProductsCurrent.variants.filter(variant => variant.option2 === "Single" && colorsToUse.includes(variant.option1));
  if (currentVariants.length === 0) return;
  const currentAvailability = Object.fromEntries(
    currentVariants.map(variant => [variant.option1, variant.available])
  );

  const selectedColorElem = document.querySelector(".product__buy .color-row-grid input[type='radio']:checked");
  if (!selectedColorElem) return;
  const selectedColor = selectedColorElem.value;
  if (selectedColor in currentAvailability && currentAvailability[selectedColor]) return;

  for (const color of colorsToUse) {
    if (color in currentAvailability && currentAvailability[color]) {
      selectedColorElem.checked = false;
      const nextAvailableColor = document.querySelector(`.product__buy .color-row-grid input[type="radio"][value="${color}"]`);
      if (nextAvailableColor) {
        nextAvailableColor.checked = true;
        nextAvailableColor.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const quantityOptions = document.querySelectorAll(`.product__buy .quantity-options input[type="radio"]`);
      for (const option of quantityOptions) {
        if (option.value === "Single") {
          option.checked = true;
          option.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          option.checked = false;
        }
      }
      break;
    }
  }
});